// libs
import React, { memo, useEffect, useMemo, useState } from 'react';

// styles
import { Container } from 'shared/components/UrgencyNudgeCoachMark/styles';

// helper
import { shouldShowCoachMark, setCoachMarkShownToUser } from './helpers';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

function UrgencyNudge() {
  const shouldShowCoachMarkOnTheTag = useMemo(() => shouldShowCoachMark(), []);
  const [hideCoachMark, setHideCoachMark] = useState(false);
  const { enabled = false, urgencyNudgeText = '' } = useRemoteConfig('urgencyNudgeCoachMark');

  useEffect(() => {
    let timerId;
    if (shouldShowCoachMarkOnTheTag || enabled || urgencyNudgeText !== '') {
      timerId = setTimeout(() => {
        setCoachMarkShownToUser();
        setHideCoachMark(true);
      }, 5000);
    }

    return () => {
      clearTimeout(timerId);
    };
  });

  if (!shouldShowCoachMarkOnTheTag || !enabled || urgencyNudgeText === '' || __SERVER__)
    return null;

  return (
    <Container hideCoachMark={hideCoachMark} data-test="urgency-nudge-coachmark">
      <div className="triangle" />
      <span className="text">{urgencyNudgeText}</span>
    </Container>
  );
}

export default memo(UrgencyNudge);
